export const url = 'https://pokeapi.co/api/v2/'
